import { withFormik } from 'formik';
import FormNames from 'common/src/app/data/enum/FormNames';
import compose from 'redux/lib/compose';
import { connect } from 'react-redux';
import { push as historyPush } from 'react-router-redux';

import Pages from 'common/src/app/data/enum/Pages';
import { setGroupSearchLoading } from 'common/src/app/actions/resources/groupSearchActions';
import { goToPlacesSearch } from 'common/src/app/actions/resources/geoLocationActions';
import GroupSearchFieldNames from 'common/src/app/data/enum/FieldNames/GroupSearchFieldNames';
import GroupSearchType from 'common/src/app/data/enum/GroupSearchType';
import { trackDomEvent } from 'common/src/app/actions/trackingActions';
import { getApiNoCache } from 'common/src/app/actions/externalApiActions';
import { POSTCODE_IO_PLACES } from 'common/src/app/data/externalApis';
import formikErrorCodes from 'common/src/app/validation/formikErrorCodes';

import getTrackingObject, { freeTextValidator } from './utils';

import FreeTextGroupSearch from './FreeTextGroupSearch';

const formikConfig = {
  displayName: FormNames.PUBLIC_GROUP_SEARCH,
  initialValues: {
    [GroupSearchFieldNames.FREE_TEXT]: '',
  },
  validate: (values, { errors }) => freeTextValidator(values, errors),
  validateOnBlur: false,
  validateOnChange: false,
  handleSubmit: async (values, { props }) => {
    const {
      pushToSearchResults,
      dispatchGroupSearchLoading,
      dispatchTrackingEvent,
      pushToOutcodeSearchResults,
      pushToPlacesLanding,
    } = props;

    const entry = values[GroupSearchFieldNames.FREE_TEXT]?.trim();

    await dispatchGroupSearchLoading();
    dispatchTrackingEvent(values[GroupSearchFieldNames.FREE_TEXT], values.searchType);

    if (values.searchType === GroupSearchType.POSTCODE) {
      return pushToSearchResults(entry);
    }

    // The member has hit enter, or hit search and a places search has been performed
    // but they have not interacted with the dropdown list of places
    if (values.searchType === GroupSearchType.PLACE) {
      // at this point we do not have the lat and the lng
      // we need to push them to the page with the term - where we can perform a places search
      pushToPlacesLanding(entry);
    }

    if (values.searchType === GroupSearchType.OUTCODE) {
      return pushToOutcodeSearchResults(entry);
    }

    // PUB-426 Always return values for DL postcode tracking consumption
    return values;
  },
};

const mapDispatchToProps = dispatch => ({
  dispatchGroupSearchLoading: () => dispatch(setGroupSearchLoading(true)),
  pushToSearchResults: result =>
    dispatch(historyPush(`${Pages.UK_PUBLIC_NEAREST_GROUP_LANDING}?query=${result}`)),
  pushToOutcodeSearchResults: result =>
    dispatch(historyPush(`${Pages.UK_PUBLIC_NEAREST_GROUP_LANDING}?outcode=${result}`)),
  pushToPlacesLanding: place =>
    dispatch(historyPush(`${Pages.UK_PUBLIC_NEAREST_GROUP_PLACES_LANDING}?place=${place}`)),
  getPlaces: (placeName, setErrors) =>
    dispatch(getApiNoCache(POSTCODE_IO_PLACES, placeName))
      .then(results => results)
      .catch(() => {
        setErrors({
          [GroupSearchFieldNames.FREE_TEXT]: formikErrorCodes.GET_PLACES_FAILED,
        });
        return null;
      }),
  goToPlaces: (latitude, longitude, placeName) =>
    goToPlacesSearch(latitude, longitude, placeName, dispatch),
  dispatchTrackingEvent: (searchEntry, searchType) =>
    dispatch(trackDomEvent(getTrackingObject(searchEntry, searchType))),
});

const connected = connect(null, mapDispatchToProps);

export default compose(connected, withFormik(formikConfig))(FreeTextGroupSearch);
